import { toast } from 'react-toastify';

export const reactQueryAPIErrorMessage = 'Whoops, something went wrong. If problem persists please contact support';
export const NETWORK_ERROR_MESSAGE = 'A Network Error Occured';
export const UNDEFINED_NETWORK_RESPONSE = 'Network Response is Undefined';

enum ToastId {
  fetchNetworkError = 1,
  clientErrorMessage = 2,
  clientSuccessMessage = 3,
}

export const generateToastMessage = (data: Record<string, any>): string => {
  const messageKeys = Object.keys(data);
  if (!messageKeys.length) return '';
  let text = '';
  messageKeys?.forEach(key => (text += `${data[key]} \n`));
  return text;
};

export const handleCustomSuccessToast = (successMessage?: string) => {
  if (successMessage) {
    toast.success(successMessage, {
      toastId: ToastId.clientSuccessMessage,
    });
  }
};

export const handleOnSuccessToast = (data: any) => {
  if (!data) {
    fetchNetworkErrorToast();
  }

  const hasMessage = data?.MESSAGES?.CLIENT_MESSAGE;

  if (hasMessage) {
    toast.success(data.MESSAGES.CLIENT_MESSAGE, {
      toastId: ToastId.clientSuccessMessage,
    });
  }
};

export const handleOnErrorToast = (data: Error) => {
  if (!data || !data.message) {
    fetchNetworkErrorToast();
  }

  // Check to see if the response data contains a custom message
  try {
    const msg = JSON.parse(data.message);
    const errorMessage = msg?.ERRORS?.CLIENT_MESSAGE;
    if (errorMessage) {
      toast.error(errorMessage, { toastId: ToastId.clientErrorMessage });
    }
  } catch (e) {
    // Fallback toast
    toast.error(data.message, { toastId: ToastId.fetchNetworkError });
  }
};

export const fetchNetworkErrorToast = () => {
  toast.error(reactQueryAPIErrorMessage, { toastId: ToastId.fetchNetworkError });
};
